<template>
    <div id="addNews">
        <top :title="title"></top>
        <div class="listBox">
            <div class="setFix"></div>
            <mt-field label="姓名" placeholder="请输入执勤者姓名" v-model="name"></mt-field>
            <mt-field label="手机号" placeholder="请输入手机号" type="tel" v-model="phone"></mt-field>
            <div class="rowItem rowItem1"
                v-if="isAdmin=='1'">
                <span class="name">添加管理员</span> 
                <mt-radio class="radios"
                v-model="isYes"
                @change="chioceVal2"
                disabled=""
                :options="options2">
                </mt-radio>
            </div>
        </div>
        <div class="btm">
            <mt-button type="danger" class="submitBtn" @click="add">添加</mt-button>
            <p class="desc">请被邀请者先注册，然后在此处输入其注册时使用的手机号。</p>
        </div>
    </div>
</template>
<script>
import Top from "@/component/top/top";
import { Toast } from 'mint-ui';
import axios from 'axios'
export default {
    components:{
        Top
    },
    data() {
        return {
            title:'添加执勤者',
            phone:'',
            name:'',
            isYes:'',
            isAdmin:this.$route.query.isAdmin,
            options2:[
                {
                    label: '社区管理员',
                    value: '社区管理员',
                },
                {
                    label: '执勤者',
                    value: '执勤者',
                },
            ],
            
        }
    },
    methods:{
        add() {
            // 判断注册或者绑定
            // this.getcurrentuserCommunity().poiId
            if(this.name == '') {
                Toast('请输入执勤者姓名')
            }else if(this.phone == '') {
                Toast('请输入手机号')
            }else{
                let params = null
                if(this.$route.query.isAdmin=='1') {
                    if(this.isYes=='社区管理员') {
                        this.level = 1
                    }else{
                        this.level = 0
                    }
                    params = {
                        token:this.getuserToken(),
                        poiId:this.$route.query.poiId,
                        mobile:this.phone,
                        name:this.name,
                        level:this.level
                    }
                }else{
                    params = {
                        token:this.getuserToken(),
                        poiId:this.$route.query.poiId,
                        mobile:this.phone,
                        name:this.name
                    }
                }
                axios.post(this.commonIp()+`/v1/communityManager`,params).then((res) => {
                        if(res.data.code == '200') {
                            this.$router.push({path:`/zqzmg?poiId=${this.$route.query.poiId}`})
                        }else{
                            Toast(res.data.message)
                        }
                    })
            }
            
            // Toast('手机号需要注册后才能邀请哦~')
            // Toast('该手机号已经绑定本小区')
        },
        chioceVal2(val){
            this.isYes = val
            if(val == '是') {
                this.showbackBox = true
            }else{
                this.showbackBox = false
            }
        },
    }
}
</script>
<style lang="less">
    @import "~@/assets/less/index.less";
    #addNews{
        .setFix{
            border-bottom:1px solid #d8d8d8;
        }
        .submitBtn{
            top:196px !important;
        }
        .mint-cell{
            border-bottom:0 !important;
        }
        .desc{
            top:250px !important;
        }
        .btm{
            position: fixed;
            width: 100%;
            height:100px;
        }
        .rowItem{
            padding:0 10px;
            border-top:1px solid #eee;
            border-bottom:1px solid #eee;
            line-height: 48px;
            &.rowItem1{
                border-bottom: 0 none;
            }
            i{
                color:red;
                font-style: normal;
            }
            .clearfix();
            span{
                .fr();
                font-size: 17px;
                color: #666;
            }
            .mint-cell-value input{
                font-size:17px;
            }
            .name{
                .fl();
                color:#000;
                font-size:17px;
            }
            .mint-cell-value input{
                font-size:15px;
            }
            .mint-radio-core{
                width: 18px;
                height: 18px;
                margin-left:2px;
            }
            .mint-radio-input:checked + .mint-radio-core{
                background:#25cf8d;
                border-color:#25cf8d;
                width:18px;
                height: 18px;
                &::after{
                    top:4px;
                    left:4px;
                }
            }
            .radios{
                .fr();
                .mint-cell-wrapper{
                    padding:0;
                    border-bottom:0;
                }
                .mint-cell{
                    .fl();
                    border-top:0;
                }
                .mint-radiolist-title{
                    display: none;
                }
            }
        }
        .submitBtn{
            bottom:auto;
            top:170px;
        }
        .desc{
            position: fixed;
            top:230px;
            text-align: center;
            width:100%;
            color:#666;
            font-size:@ft12;
        }
        .mint-cell{
            border-bottom:1px solid #d8d8d8;
        }
        .mint-cell:last-child{
            background-image:none;
        }
        .mint-cell-wrapper{
            background-image:none;
            border-bottom:1px solid #eee;
        }
    }
</style>


// WEBPACK FOOTER //
// src/pages/addnew/addnew.vue